import React from 'react';
import { cn } from '../utils/style';

function InvoiceField({name, value, className, hide}) {
    if (hide) return <></>;
    return (
        <div className={cn("transition-all duration-200 ease-in-out hover:shadow-sm hover:bg-gray-50/50 p-2 rounded-md bg-white border border-gray-100", className)}>
            {name && <div className="uppercase text-xs font-medium text-gray-500 mb-0.5">{name}</div>}
            <div className="text-gray-800 font-medium text-sm">{value || 'N/A'}</div>
        </div>
    )
}

export default InvoiceField;